import { Analytics } from '@cobliteam/analytics';
import { cn } from '@cobliteam/colib-ui/cn';
import Icon, { type IconName } from '@cobliteam/colib-ui/Icon';
import Separator from '@cobliteam/colib-ui/Separator';
import Typography from '@cobliteam/colib-ui/Typography';
import { useTranslation } from '@cobliteam/i18n';
import { getTextForLanguage } from '../../../utils';
import { useVisitedPage } from '../hooks';
import LinkWrapper from './LinkWrapper';
import { SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenuButton, SidebarMenuItem, SidebarMenuSub } from './Sidebar';

const MostVisitedMenu = () => {
  const { t } = useTranslation('ui-business');
  const { visitedPages } = useVisitedPage();
  return (
    <div className={cn('space-y-2')}>
      <SidebarGroup>
        <Separator className='my-2 bg-zinc-300 dark:bg-border' />
        <SidebarGroupLabel className='!text-xs !text-sidebar-foreground font-medium'>{t('most_visited.featured')}</SidebarGroupLabel>

        {visitedPages.length > 0 ? (
          <SidebarGroupContent>
            <SidebarMenuSub className='mx-2 translate-x-0 gap-0 border-l-0 px-0 py-0'>
              {visitedPages.map((visitedPage) => {
                const goTo: string = visitedPage.page.url ?? '#';
                const routeTitle = getTextForLanguage(visitedPage.page.title, 'pt-BR');
                const pageId: string = visitedPage.page.id ?? '';
                return (
                  <SidebarMenuItem key={pageId}>
                    <SidebarMenuButton
                      title={routeTitle}
                      render={
                        <LinkWrapper
                          to={goTo}
                          pageId={pageId}
                          onClick={() =>
                            Analytics.track('Sidebar - Navigate', {
                              destination: routeTitle,
                              source: 'Most Visited Menu',
                            })
                          }
                        >
                          {visitedPage?.page.sidebar?.icon && <Icon size='sm' name={visitedPage.page.sidebar?.icon as IconName} className='size-4' />}
                          <span className='flex-1'>{routeTitle}</span>
                        </LinkWrapper>
                      }
                    />
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenuSub>
          </SidebarGroupContent>
        ) : (
          <SidebarGroupContent>
            <SidebarMenuSub className='mx-2 translate-x-0 gap-0 border-l-0 px-0 py-0'>
              <SidebarMenuItem className='mt-10 flex flex-col items-center justify-center gap-2'>
                <Icon name='text-select' className='size-12 text-muted-foreground' size='lg' />
                <Typography variant='caption' className='gap-1 break-words text-foreground text-muted-foreground'>
                  {t('most_visited.no_recent_destinations')}
                </Typography>
              </SidebarMenuItem>
            </SidebarMenuSub>
          </SidebarGroupContent>
        )}
      </SidebarGroup>
    </div>
  );
};
export default MostVisitedMenu;
